document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bundle-add-to-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ids = JSON.parse(btn.dataset.variantIds);
      if (!ids || !ids.length) return;

      var textEl = btn.querySelector('.bundle-add-to-cart-btn__text');
      var spinnerEl = btn.querySelector('.loading-overlay__spinner');
      textEl.classList.add('hidden');
      spinnerEl.classList.remove('hidden');
      btn.disabled = true;

      var discountCode = btn.dataset.discountCode;
      var upsellFor = btn.dataset.upsellFor;
      var items = ids.map(function (id) {
        var item = { id: id, quantity: 1 };
        if (discountCode && upsellFor && String(id) !== String(upsellFor)) {
          item.properties = { '_upsell_for': upsellFor, '_upsell_discount_code': discountCode };
        }
        return item;
      });

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          textEl.classList.remove('hidden');
          spinnerEl.classList.add('hidden');
          btn.disabled = false;

          if (data.status) return;

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-add-to-cart', cartData: data });
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function () {
          textEl.classList.remove('hidden');
          spinnerEl.classList.add('hidden');
          btn.disabled = false;
        });
    });
  });
});
